import { render, staticRenderFns } from "./newArrivals.vue?vue&type=template&id=b02d8a60&scoped=true&"
import script from "./newArrivals.vue?vue&type=script&lang=js&"
export * from "./newArrivals.vue?vue&type=script&lang=js&"
import style0 from "./newArrivals.vue?vue&type=style&index=0&id=b02d8a60&prod&lang=stylus&scoped=true&"
import style1 from "./newArrivals.vue?vue&type=style&index=1&id=b02d8a60&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02d8a60",
  null
  
)

export default component.exports